import { API } from "@/lib/api";
import { X, FileText, File as FileIcon, Folder, Download } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const token = () => localStorage.getItem("l30m_token");
export const fileUrl = (id) => `${API}/portal/files/${id}/download?auth=${token()}`;
export const driveFileUrl = (id) => `${API}/portal/drive/file/${id}/download?auth=${token()}`;
export const isImage = (ct = "") => (ct || "").startsWith("image/");
export const isPdf = (ct = "") => (ct || "").includes("pdf");

export function FileThumb({ file, onClick, className = "w-11 h-11" }) {
  const clickable = onClick && !file.is_folder;
  const base = `${className} rounded-md shrink-0 overflow-hidden ${clickable ? "cursor-pointer" : ""}`;
  if (file.is_folder)
    return <div className={`${base} bg-gold/10 flex items-center justify-center`}><Folder className="w-5 h-5 text-gold" /></div>;
  if (isImage(file.content_type))
    return <img src={fileUrl(file.id)} alt="" onClick={clickable ? onClick : undefined} loading="lazy"
      className={`${base} object-cover border border-white/10`} data-testid={`thumb-${file.id}`} />;
  if (isPdf(file.content_type))
    return <div className={`${base} bg-red-500/15 flex items-center justify-center`} onClick={clickable ? onClick : undefined} data-testid={`thumb-${file.id}`}><FileText className="w-5 h-5 text-red-400" /></div>;
  return <div className={`${base} bg-gold/10 flex items-center justify-center`} onClick={clickable ? onClick : undefined}><FileIcon className="w-5 h-5 text-gold" /></div>;
}

export function FilePreviewModal({ file, onClose }) {
  const name = file ? (file.original_filename || file.name) : "";
  const ct = file ? (file.content_type || file.mimeType) : "";
  const url = file ? (file.driveUrl || fileUrl(file.id)) : "";
  return (
    <AnimatePresence>
      {file && (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose}>
          <motion.div initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }}
            onClick={(e) => e.stopPropagation()} className="w-full max-w-4xl bg-[#0B2A52] border border-white/10 rounded-xl overflow-hidden" data-testid="preview-modal">
            <div className="flex items-center justify-between px-5 py-3 border-b border-white/10">
              <p className="font-mono text-xs truncate text-[#C7CAD1]">{name}</p>
              <div className="flex items-center gap-4">
                <a href={url} target="_blank" rel="noopener noreferrer" title="Télécharger" className="text-[#A0B2CE] hover:text-gold"><Download className="w-4 h-4" /></a>
                <button onClick={onClose} data-testid="preview-close"><X className="w-5 h-5 text-[#A0B2CE]" /></button>
              </div>
            </div>
            <div className="bg-black h-[75vh] flex items-center justify-center">
              {isImage(ct) ? (
                <img src={url} alt="" className="max-h-full max-w-full object-contain" />
              ) : isPdf(ct) ? (
                <iframe title="preview" src={url} className="w-full h-full" />
              ) : (
                <div className="text-center text-[#A0B2CE] p-10">
                  <p className="mb-4">Aperçu non disponible pour ce type de fichier.</p>
                  <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gold text-ink px-5 py-2.5 rounded-full font-mono text-[11px] uppercase tracking-[0.1em]"><Download className="w-4 h-4" /> Télécharger</a>
                </div>
              )}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
